import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Collapse, IconButton, Typography } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoyaltyDiscount from "../../components/FIOFID/LoyaltyDiscount/LoyaltyDiscount";
import CheckoutForm from "../../components/PaymentPage/CheckoutForm/CheckoutForm";
import CodePromo from "../../components/PaymentPage/CodePromo/CodePromo";
import DeliveryDetails from "../../components/PaymentPage/DeliveryDetails/DeliveryDetails";
import InvoiceCommand from "../../components/PaymentPage/InvoiceCommand/InvoiceCommand";
import PaymentInfo from "../../components/PaymentPage/PaymentInfo/PaymentInfo";
import PaymentMethod from "../../components/PaymentPage/PaymentMethod/PaymentMethod";
import PlanificationMethod from "../../components/PaymentPage/PlanificationMethod/PlanificationMethod";
import ProcessingCommand from "../../components/PaymentPage/ProcessingCommand";
import PromoGroup from "../../components/PaymentPage/PromoGroup/PromoGroup";
import RestaurantInfo from "../../components/PaymentPage/RestaurantInfo/RestaurantInfo";
import AppNavbar from "../../components/shared/AppNavbar/AppNavbar";
import Footer from "../../components/shared/Footer/Footer";
import AddressSelectionModal from "../../components/shared/Modals/AddressSelectionModal/AddressSelectionModal";
import RestaurantErrorModal from "../../components/shared/Modals/RestaurantErrorModal/RestaurantErrorModal";
import RewardModal from "../../components/shared/Modals/RewardModal/RewardModal";
import OrderDetails from "../../components/shared/OrderDetails/OrderDetails";
import { getDiningModeLabel, MODE_DELIVERY } from "../../constants/constants";
import { useConfig } from "../../context/ConfigContext";
import { languageData } from "../../i18n";
import LeftArrow from "../../images/arrow-left_grey.svg";
import {
  Cart,
  CategoryItem,
  Restaurant,
  RestaurantCart,
} from "../../interfaces/Catalogue";
import { DeliveryQuote } from "../../interfaces/delivery";
import {
  CodePromoSuggestion,
  LoyalityGroup,
  LoyaltyClient,
  PanierDiscount,
  PromoType,
} from "../../interfaces/loyality.interface";
import { shopApi } from "../../services/apiGate";
import { deliveryApi } from "../../services/deliveryApi";
import { loyalityApi } from "../../services/loyalityApi";
import { clearStoreItem, getmyprofile } from "../../store/actions/actions";
import { updateCart } from "../../store/cart/cartActions";
import { setDeliveryAddress } from "../../store/delivery/deliveryActions";
import {
  calculateFinalTime,
  isTimeWithinRange,
  selectedTimeRightISO,
} from "../../utils/dateUtils";
import {
  calculateTotalDuration,
  convertTimeToMinutes,
} from "../../utils/deliveryUtils";
import {
  calculatePromoCodeDiscount,
  calculateTotalLoyaltyPtsConsumedForOrder,
  calculDiscountAmountForLoyaltyGroup,
} from "../../utils/loyaltyUtils";
import {
  calculateCartDiscount,
  calculateTotalArticlesPrice,
  centimesToEuros,
} from "../../utils/priceUtils";
import "./PaymentPage.scss";

const PaymentPage = (props: any) => {
  const { config } = useConfig();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const restaurantId = localStorage.getItem("restaurantId");
  const deliveryAddress = useSelector(
    (state: any) => state.delivery.deliveryAddress
  );
  const userInfo = useSelector((state: any) => state.auth.userInfo);
  const restaurantCarts = useSelector(
    (state: { cart: Cart }) => state.cart.restaurantCarts
  );

  const [selectedTimeRight, setSelectedTimeRight] = useState("");
  const [deliveryQuote, setDeliveryQuote] = useState<DeliveryQuote>();
  const [restaurantCart, setRestaurantCart] = useState<RestaurantCart>(
    restaurantCarts[Number(restaurantId) || 0]
  );
  const [restaurant, setRestaurant] = useState<Restaurant>();
  const [tempsPreparation, setTempsPreparation] = useState<
    string | undefined
  >();
  const [showMarker, setshowMarker] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [isOnlinePaymentChecked, setOnlinePaymentChecked] = useState(true);
  const [isMaintenantChecked, setIsMaintenantChecked] = useState(false);
  const [showProcessingCommand, setShowProcessingCommand] = useState(false);
  const [isValidTime, setIsValidTime] = useState(false);

  const [openModals, setOpenModals] = useState<Record<string, boolean>>({});
  const stripPublicKey = localStorage.getItem("stripe_public_key") || "";
  const stripePromise = loadStripe(stripPublicKey);
  const [promptCommand, setpromptCommand] = useState(false);
  const [command, setcommand] = useState();

  const [showDeliveryErrorModal, setShowDeliveryErrorModal] = useState(false);
  const [showChangeAddressModal, setShowChangeAddressModal] = useState(false);

  const [userLoyalityPoints, setUserLoyalityPoints] = useState(0);

  const [totalLoyaltyPtsConsomed, setTotalLoyaltyPtsConsomed] = useState(0.0);
  const [supTotal, setSupTotal] = useState(0.0);
  const [fees, setFees] = useState(0.0);

  const [discountAmount, setDiscountAmount] = useState<number>(0);
  const [finalTotal, setFinalTotal] = useState<number>(
    supTotal + fees - discountAmount
  );

  const [qrcode, setqrcode] = useState("");
  const [loyalityClient, setLoyalityClient] = useState<LoyaltyClient>({
    EarnedPoints: 0,
    TotalPoints: 0,
    EarnedPtFromFirstOrderReward: 0,
    EarnedPtFromNbVisitsReward: 0,
  });

  // loaylty logic

  const [appliedPromo, setAppliedPromo] = useState<PromoType>(null);

  const [panierDiscount, setPanierDiscount] =
    useState<PanierDiscount>();
  const [groupDiscount, setGroupDiscount] = useState<LoyalityGroup>();
  const [promoCodeDiscount, setPromoCodeDiscount] =
    useState<CodePromoSuggestion>();
  const [promoCodeDiscountError, setPromoCodeDiscountError] = useState("");

  const [articlePriceOriginal, setArticlePriceOriginal] = useState(0);
  const [articlePriceDiscounted, setArticlePriceDiscounted] = useState(0);
  const [cartOpen, setCartOpen] = useState(true);


  const isDeliveryMode = restaurantCart?.mode === MODE_DELIVERY;
  const deliveryDuration =
    restaurantCart?.restaurant?.deliveryRestaurantDuration;
  const prepareDuration = restaurantCart?.restaurant?.prepareRestaurantDuration;
  const { open: min = "00:00", close: max = "00:00" } =
    restaurantCart?.restaurant?.shifts?.[0] || {};
  const prepdate = restaurantCart?.restaurant?.tempsPrep || 0;
  const todayDate = dayjs().format("YYYY-MM-DD");
  const combinedDateTime = dayjs(`${todayDate}T${min}`).add(prepdate, "minute");

  const [selectedTimee, setSelectedTimee] = useState(combinedDateTime);
  const [pickedTime, setPickedTime] = useState(combinedDateTime);

  const OpenTime = dayjs(`${todayDate}T${min}`);
  const ClosedTime = dayjs(`${todayDate}T${max}`);

  const combinedDateTime2 = dayjs(`${todayDate}T${max}`).subtract(
    prepdate,
    "minute"
  );

  const PrepareFor = isMaintenantChecked
    ? selectedTimeRightISO(selectedTimeRight)
    : null;

  // console.log("🚀 ~ PaymentPage ~ panierDiscount:", panierDiscount)

  useEffect(() => {
    setPickedTime(
      calculateFinalTime(
        isValidTime,
        combinedDateTime,
        combinedDateTime2,
        selectedTimee,
        prepdate,
        selectedTimeRight
      )
    );
  }, [selectedTimee, selectedTimeRight]);

  useEffect(() => {
    const fetchRestaurant = async () => {
      try {
        const res = await shopApi.getResturantById({
          id: Number(restaurantId),
          diningMode: restaurantCart?.mode || 0,
          adresse: {
            latitude: props.location?.lat,
            longitude: props.location?.lng,
          },
        });

        setRestaurant(res?.data?.restaurant);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getPanierDiscount = async () => {
      try {

        const res = await loyalityApi.fetchSuggestionDiscountForUser(
          String(restaurantId)
        );
        if (res.data.errorMessage === null) {
          setPanierDiscount({
            ...res.data,
            cartRewardDiscountType: res.data.cartRewardDiscountType ?? 0,
          });
        }
      } catch (error) {
        console.error("Error fetching suggestion data:", error);
      }
    };

    if (restaurantId) {
      fetchRestaurant();
      getPanierDiscount();
    }
  }, [restaurantId]);

  useEffect(() => {
    const fetchClientData = async () => {
      if (!restaurant) return;

      try {
        const res = await loyalityApi.getClientBySecretCode(
          userInfo?.qrCodeValue,
          restaurant.azureUrl
        );

        const { fidGroupClient, loyalityPoints } = res?.data || {};

        setGroupDiscount(fidGroupClient);
        setUserLoyalityPoints(loyalityPoints);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchClientData();
  }, [restaurant]);

  useEffect(() => {
    if (restaurantCart?.mode === MODE_DELIVERY && restaurant) {
      setOnlinePaymentChecked(true);
      checkRestaurantDelivery(deliveryAddress);
    }
  }, [restaurantCart, restaurant]);

  useEffect(() => {
    setShowProcessingCommand(false);

    if (restaurantCart?.restaurant?.isOnSpotPaymentActive) {
      setOnlinePaymentChecked(true);
    }

    const totalArticlesPriceWithoutDiscount = calculateTotalArticlesPrice(
      restaurantCart?.categories,
      restaurantCart?.mode,
      false
    );

    setSupTotal(totalArticlesPriceWithoutDiscount);

    setFees(0);

    props.getmyprofile();

    if (localStorage.getItem("redirectedToAuth")) {
      localStorage.setItem("redirectedToAuth", "false");
    }
    setTimeout(() => {
      setshowMarker(true);
    }, 2000);
  }, [restaurantCarts]);

  useEffect(() => {
    if (discountAmount > supTotal) {
      setDiscountAmount(supTotal);
    }
    setFinalTotal(Math.max(0, supTotal - discountAmount + fees));
  }, [supTotal, discountAmount, fees]);

  useEffect(() => {
    if (!isValidTime) {
      setIsValidTime(true);
    }

    const currentDateTime = dayjs();
    const selectedDateTime = dayjs(`${todayDate}T${selectedTimeRight}`);

    if (currentDateTime.isAfter(selectedDateTime)) {
      setSelectedTimeRight(currentDateTime.format("HH:mm"));
    } else {
      console.log("Current time is after or equal to the selected time.");
    }
  }, [selectedTimeRight, isValidTime, todayDate]);

  useEffect(() => {
    let newTempsPreparation: string | undefined;

    if (isDeliveryMode && deliveryDuration) {
      const addedDuration = deliveryQuote?.duration || 0;
      newTempsPreparation = calculateTotalDuration(
        deliveryDuration,
        addedDuration
      );
    } else {
      newTempsPreparation = prepareDuration;
    }

    setTempsPreparation(newTempsPreparation);

    setFees(centimesToEuros(deliveryQuote?.fee || 0));
  }, [deliveryQuote, restaurantCart,restaurantCarts]);

  useEffect(() => {
    if (loyalityClient) {
      handleShowRewardModal();
    }
  }, [loyalityClient]);

  useEffect(() => {
    const removeRestaurantFromrestaurantCarts = () => {
      if (restaurantCart) {
        delete restaurantCarts[restaurantCart?.restaurant?.id];
        dispatch(updateCart(restaurantCarts));
      }
    };

    if (command) {
      removeRestaurantFromrestaurantCarts();
    }
  }, [command]);

  useEffect(() => {
    setRestaurantCart(restaurantCarts[Number(restaurantId) || 0]);
  }, [restaurantCarts, restaurantId]);

  const handleTimeChange = (newValue: any) => {
    const isValid = isTimeWithinRange(newValue, min, max);

    if (!isValid) {
      setIsValidTime(false);
      setSelectedTimee(combinedDateTime2);
      setSelectedTimeRight(combinedDateTime.format("HH:mm"));
    } else {
      setIsValidTime(true);
      setSelectedTimee(newValue);
      setSelectedTimeRight(newValue.format("HH:mm"));
    }
  };

  const checkRestaurantDelivery = async (
    deliveryAddress: google.maps.places.PlaceResult | undefined
  ) => {
    deliveryApi
      .checkRestaurantDelivery(
        String(restaurant?.id),
        deliveryAddress,
        userInfo.phoneNumber,
        (supTotal + fees).toFixed(2)
      )
      .then((res) => {
        setDeliveryQuote(res.data);
        dispatch(setDeliveryAddress(deliveryAddress));
        setShowDeliveryErrorModal(false);
        setShowChangeAddressModal(false);
      })
      .catch((error) => {
        setShowChangeAddressModal(false);
        setShowDeliveryErrorModal(true);
        console.log("error", error);
      });
  };

  const handleShowRewardModal = () => {
    const modalsToShow: Record<string, boolean> = {};

    // Check each key in the object and open modal only if value > 0
    Object.entries(loyalityClient).forEach(([key, value]) => {
      if (key !== "TotalPoints" && value > 0) {
        modalsToShow[key] = true;
      }
    });

    setOpenModals(modalsToShow);
  };

  const handleCloseRewardModal = (key: string) => {
    setOpenModals((prev) => ({ ...prev, [key]: false }));
  };

  function resetDiscountedPrices(
    restaurantCart: RestaurantCart
  ): RestaurantCart {

    return {
      ...restaurantCart,
      categories: restaurantCart?.categories?.map(
        (categoryItem: CategoryItem) => ({
          ...categoryItem,
          discountedPrice: null,
          isRemiseActive: false,
          order: categoryItem?.order?.map((order) => ({
            ...order,
            selectedArticles: order?.selectedArticles.map(
              (selectedArticle) => ({
                ...selectedArticle,
                selectedMenuItem: {
                  ...selectedArticle?.selectedMenuItem,
                  discountedPrice: null,
                  isRemiseActive: false,
                },
              })
            ),
          })),
        })
      ),
    };
  }

  const handlePressbtnModal = () => {
    setShowDeliveryErrorModal(false);
    setShowChangeAddressModal(true);
  };


  const handleApplyPromoCode = async () => {
    console.log("handleApplyPromoCode");
    if (appliedPromo === "CODE_PROMO") {
      autoResetArticleDiscount();
      setAppliedPromo(null);
      setPromoCodeDiscount(undefined);
    } else {
      try {
        const res = await loyalityApi.applyPromoCode(
          String(restaurantId),
          promoCode
        );

        if (res?.data?.result) {
          setPromoCodeDiscount(res.data.result);
          setPromoCodeDiscountError("");
          if (supTotal >= res.data.result.cartThreshold) {
            autoResetArticleDiscount();
            setAppliedPromo("CODE_PROMO");
          }
        }
      } catch (error: any) {
        setPromoCodeDiscount(undefined);
        console.error("🚀 ~ applyPromoCode ~ error:");
        setPromoCodeDiscountError(
          error?.response?.data?.failureResponse?.codeFI?.code || "default"
        );

        // Try fallback
        console.error("Trying applyFidPromoCode after error");
      }
    }
  };

  const handleTogglePanierDiscount = (): void => {

    if (appliedPromo === "PANIER") {
      autoResetArticleDiscount();
      setAppliedPromo(null);
    } else if (supTotal >= (panierDiscount?.cartRewardThresholdMin ?? 0)) {
      autoResetArticleDiscount();
      setAppliedPromo("PANIER");
    }
  };

  const autoApplyArticleDiscount = (): void => {
    const { categories, mode } = restaurantCart ?? {};

    const totalPriceWithoutDiscount = calculateTotalArticlesPrice(
      categories,
      mode,
      false
    );

    const totalPriceWithDiscount = calculateTotalArticlesPrice(
      categories,
      mode,
      true
    );

    if (totalPriceWithoutDiscount > totalPriceWithDiscount) {
      setAppliedPromo(null);
      setAppliedPromo("ARTICLE");
    } else if (appliedPromo == "ARTICLE") {
      setAppliedPromo(null);
    }

    setArticlePriceOriginal(totalPriceWithoutDiscount);
    setArticlePriceDiscounted(totalPriceWithDiscount);
  };

  const applyGroupDiscountIfNoPromo = (): void => {
    if (
      !appliedPromo &&
      groupDiscount &&
      supTotal > (groupDiscount.isFormule ? groupDiscount.partSalariale : groupDiscount.seuil)
    ) {
      autoResetArticleDiscount();
      setAppliedPromo("GROUP");
    }
  };

  const autoResetArticleDiscount = () => {
    if (appliedPromo == "ARTICLE") {
      // Create an updated restaurant cart with discounted prices reset
      const updatedRestaurantCart = resetDiscountedPrices(restaurantCart);
      // Dispatch the updated restaurant cart
      dispatch(
        updateCart({
          ...restaurantCarts,
          [String(restaurantId)]: updatedRestaurantCart,
        })
      );
    }
  };

  const updateDiscountAmountBasedOnPromo = (promo: PromoType): void => {
    switch (promo) {
      case "PANIER":
        // console.log("updateDiscountAmountBasedOnPromo CODE_PROMO");
        if (panierDiscount) {
          const discount = calculateCartDiscount(supTotal, panierDiscount);
          setDiscountAmount(discount);
          setTotalLoyaltyPtsConsomed(panierDiscount?.cartRewardTotalPtRequired);
        }
        break;

      case "CODE_PROMO":
        // console.log("updateDiscountAmountBasedOnPromo CODE_PROMO");
        if (promoCodeDiscount) {
          const discount = calculatePromoCodeDiscount(
            supTotal,
            promoCodeDiscount
          );
          setDiscountAmount(discount);
          setTotalLoyaltyPtsConsomed(0);
        }
        break;

      case "ARTICLE":
        // console.log("updateDiscountAmountBasedOnPromo ARTICLE");
        const newDisocuntAmount = articlePriceOriginal - articlePriceDiscounted;
        setDiscountAmount(newDisocuntAmount);
        setTotalLoyaltyPtsConsomed(
          calculateTotalLoyaltyPtsConsumedForOrder(restaurantCart?.categories)
        );
        break;

      case "GROUP":
        // console.log("updateDiscountAmountBasedOnPromo GROUP");
        if (groupDiscount) {
          const discount = calculDiscountAmountForLoyaltyGroup(
            groupDiscount,
            supTotal
          );
          setDiscountAmount(discount);
          setTotalLoyaltyPtsConsomed(0);
        }
        break;

      default:
        setDiscountAmount(0);
        setTotalLoyaltyPtsConsomed(0);
        console.log("DEFAULT");
        break;
    }
  };

  const validateDiscountThreshold = (
    promo: PromoType,
    supTotal: number
  ): void => {
    switch (promo) {
      case "PANIER":
        if (supTotal < (panierDiscount?.cartRewardThresholdMin ?? 0)) {
          setAppliedPromo(null);
        }
        break;

      case "CODE_PROMO":
        if (supTotal < (promoCodeDiscount?.cartThreshold ?? 0)) {
          setAppliedPromo(null);
        }
        break;

      case "GROUP":
        const threshold = groupDiscount?.isFormule
          ? groupDiscount.partSalariale
          : groupDiscount?.seuil;

        if (groupDiscount && (supTotal < (threshold ?? 0))) {
          setAppliedPromo(null);
        }
        break;

      default:
        console.log("DEFAULT");
        break;
    }
  };

  useEffect(() => {
    autoApplyArticleDiscount();
  }, [restaurantCarts]);

  useEffect(() => {
    if (supTotal > 0) {
      applyGroupDiscountIfNoPromo();
      updateDiscountAmountBasedOnPromo(appliedPromo);
      validateDiscountThreshold(appliedPromo, supTotal);
      if (appliedPromo != "CODE_PROMO" && appliedPromo != "GROUP") {
        setPromoCodeDiscount(undefined);
      }
    }
  }, [appliedPromo, supTotal, groupDiscount]);

  return (
    <div className="PaiementPage">
      <section>
        <AppNavbar />
        <div className="body-wrapper">
          <div className="TopPageHeader">
            <div onClick={() => navigate(-1)}>
              <div>
                <img src={LeftArrow} alt="" />
                <p>Paiement</p>
              </div>
            </div>
          </div>
          <main className="paimentSection">
            <div className="body-paiment">
              <div className="body-wrapper">
                {/* RestaurantInfo */}
                {restaurantCart && (
                  <RestaurantInfo
                    restaurantId={Number(restaurantId)}
                    restaurantCart={restaurantCart}
                    showMarker={showMarker}
                    isMaintenantChecked={isMaintenantChecked}
                    tempsPreparation={tempsPreparation}
                    userLoyalityPoints={userLoyalityPoints}
                  />
                )}

                {/* DELIVERY */}
                {restaurantCart && deliveryQuote && (
                  <div className="CartComponents">
                    <p className="block-title">Détails de la livraison</p>
                    <DeliveryDetails
                      restaurantCart={restaurantCart}
                      deliveryQuote={deliveryQuote}
                      userInfo={userInfo}
                      checkRestaurantDelivery={checkRestaurantDelivery}
                      onShowChangeAddressModal={() =>
                        setShowChangeAddressModal(true)
                      }
                    />
                  </div>
                )}

                {/* Panier */}
                {restaurant !== undefined && restaurantCart !== undefined && (
                  <div className="CartComponents">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                        mb: 1,
                      }}
                      onClick={() => setCartOpen((prev) => !prev)} // Toggle collapse
                    >
                      <p className="block-title">Panier</p>
                      <IconButton size="small">
                        {cartOpen ? <ExpandLess /> : <ExpandMore />}
                      </IconButton>
                    </Box>

                    <Collapse in={cartOpen}>
                      <OrderDetails
                        categories={restaurantCart?.categories}
                        orderType={restaurantCart?.mode || 0}
                        canApplyArticleDiscount={panierDiscount == panierDiscount}
                        canEditQuantity={true}
                        restaurantId={restaurant.id}
                        userLoyalityPoints={userLoyalityPoints}
                        totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed}
                        rewardClaimDisabled={
                          appliedPromo == "PANIER" || appliedPromo == "CODE_PROMO"
                        }
                      />
                    </Collapse>
                  </div>
                )}

                <div className={`payment-methode  show-card `}>


                  {/* PAYMENT INFO */}
                  <PaymentInfo
                    supTotal={supTotal}
                    discountAmount={discountAmount}
                    fees={fees}
                    finalTotal={finalTotal}
                    totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed}
                  />

                  {/* PROMO GROUP */}
                  {groupDiscount && (
                    <PromoGroup groupDiscount={groupDiscount} />
                  )}

                  {/* DISCOUNT SUGGESTION */}
                  {(panierDiscount && !groupDiscount) && (
                    <LoyaltyDiscount
                      panierDiscount={panierDiscount}
                      onApplyDiscount={handleTogglePanierDiscount}
                      onCancelDiscount={handleTogglePanierDiscount}
                      isPanierDiscountApplied={appliedPromo == "PANIER"}
                      isPanierDiscountDisabled={
                        panierDiscount?.cartRewardThresholdMin == null
                          ? false
                          : supTotal < panierDiscount?.cartRewardThresholdMin ||
                          appliedPromo == "CODE_PROMO" ||
                          appliedPromo == "ARTICLE"
                      }
                    />
                  )}

                  {/* Code Promo */}
                  {!groupDiscount &&
                    <CodePromo
                      isDisabled={
                        appliedPromo == "ARTICLE" || appliedPromo == "PANIER"
                      }
                      promoCode={promoCode}
                      setPromoCode={setPromoCode}
                      onSubmit={handleApplyPromoCode}
                      promoCodeError={promoCodeDiscountError}
                      isPromoCodeApplied={appliedPromo === "CODE_PROMO"}
                      codePromoSuggestion={promoCodeDiscount}
                      showError={
                        supTotal < (promoCodeDiscount?.cartThreshold || 0)
                      }
                    />}

                  {/* Planification method */}
                  {restaurantCart?.mode !== MODE_DELIVERY && (
                    <PlanificationMethod
                      isMaintenantChecked={isMaintenantChecked}
                      handlePlanificationMethodChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setIsMaintenantChecked(
                          event.target.value === "planifier"
                        );
                      }}
                      tempsPreparation={tempsPreparation}
                      OpenTime={OpenTime}
                      ClosedTime={ClosedTime}
                      pickedTime={pickedTime}
                      handleTimeChange={handleTimeChange}
                    />
                  )}

                  {/* PAYMENT METHOD */}
                  {/* {restaurantCart?.mode !== MODE_DELIVERY && (
                    <PaymentMethod
                      restaurantCart={restaurantCart}
                      isOnlinePaymentChecked={isOnlinePaymentChecked}
                      handlePaymentMethodChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setOnlinePaymentChecked(
                          event.target.value === "online"
                        );
                      }}
                    />
                  )}  */}

                  {/* STRIP PAYMENT */}
                  <div className="card-section">
                    <Elements
                      stripe={stripePromise}
                      options={{
                        mode: "payment",
                        amount: 350,
                        currency: "eur",
                      }}
                    >
                      {
                        restaurant && (

                          <CheckoutForm
                            restaurant={restaurant}
                            restaurantCart={restaurantCart}
                            isOnlinePaymentChecked={isOnlinePaymentChecked}
                            isMaintenantChecked={isMaintenantChecked}
                            appliedPromo={appliedPromo}
                            panierDiscount={panierDiscount}
                            codePromoSuggestion={promoCodeDiscount}
                            groupDiscount={groupDiscount}
                            isValidTime={isValidTime}
                            selectedTimeRight={selectedTimeRight}
                            quoteId={deliveryQuote?.id}
                            estimatedDeliveryQuoteMinutes={convertTimeToMinutes(
                              tempsPreparation || "00:00"
                            )}
                            supTotal={supTotal}
                            fees={fees}
                            discountAmount={discountAmount}
                            finalTotal={finalTotal}
                            totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed}
                            userLoyalityPoints={userLoyalityPoints}
                            promoCode={promoCode}
                            setLoyalityClient={setLoyalityClient}
                            setqrcode={(str: string) => setqrcode(str)}
                            setcommand={(command: any) => setcommand(command)}
                            setpromptCommand={(value: boolean) =>
                              setpromptCommand(value)
                            }
                            setShowProcessingCommand={() =>
                              setShowProcessingCommand(true)
                            }
                            setOnlinePaymentChecked={setOnlinePaymentChecked}
                          />)
                      }
                    </Elements>
                  </div>
                </div>
              </div>
            </div>
          </main>

          {Object.entries(openModals)?.map(([key, isOpen]) =>
            isOpen ? (
              <RewardModal
                key={key}
                eventType={key}
                points={loyalityClient[key as keyof typeof loyalityClient]}
                onClickClose={() => handleCloseRewardModal(key)}
                onClickValidate={() => navigate("/FIOFID")}
              />
            ) : null
          )}

          {showProcessingCommand && (
            <div className="ProcessingCommandComponent">
              <ProcessingCommand
                resturant={restaurant?.nom}
                distance={restaurant?.address}
                tempsPrep={tempsPreparation}
                placement={getDiningModeLabel(restaurantCart?.mode || 0)}
              />
            </div>
          )}

          {promptCommand && (
            <div className="InvoiceCommandComponent ">
              <InvoiceCommand
                command={command}
                qrcode={qrcode}
                restaurantCart={restaurantCart}
                PrepareFor={PrepareFor}
                discountAmount={discountAmount}
                totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed}
              />
            </div>
          )}

          <RestaurantErrorModal
            showRestaurantError={showDeliveryErrorModal}
            onPressBtn={handlePressbtnModal}
            onCloseModal={() => setShowDeliveryErrorModal(false)}
            modalTitle={languageData.fr.delivery.deliveryErrorModal.title}
            modalDescription={
              languageData.fr.delivery.deliveryErrorModal.message
            }
            modalButtonLabel={
              languageData.fr.delivery.deliveryErrorModal.actionButtonLabel
            }
          />

          <AddressSelectionModal
            showModal={showChangeAddressModal}
            restaurantId={String(restaurantId)}
            hideModal={() => setShowChangeAddressModal(false)}
            onConfirmAddress={checkRestaurantDelivery}
          />
        </div>
      </section>
      {config?.isGlobalWebsite && <Footer />}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    restaurantCarts: state.cart.restaurantCarts,
    location: state.auth.location,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getmyprofile: () => dispatch(getmyprofile()),
    clearItemStore: (item: string) => dispatch(clearStoreItem(item)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPage);
